import React, { useState } from "react";
import axios from "axios";
import { FiSend } from 'react-icons/fi';
import { FiEye, FiEyeOff } from "react-icons/fi";

const AddProfileBtn = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
    annual_income: "",
    marital_status: "",
    education: "",
    city: "",
    gender: "",
    religion: "",
    date_of_birth: "",
    caste: "",
    height: "",
    occupation: "",
    about: "",
    looking_for: "",
    photo: null,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword(prev => !prev);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, photo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Your existing validation code...

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "date_of_birth") {
        const formattedDate = new Date(formData.date_of_birth).toISOString().split("T")[0];
        data.append("date_of_birth", formattedDate);
      } else {
        data.append(key, formData[key]);
      }
    });

    try {
      const response = await axios.post(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/insert_profile.php",
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("Response:", response.data);

      // Show popup on success
      setShowPopup(true);

      // Optional: Hide popup after 3 seconds
      setTimeout(() => {
        setShowPopup(false);
        window.location.reload();  // Reload or reset form here if needed
      }, 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed! Please try again.");
    }
  };

  return (
    <>
      <div className="pt-20 pb-20 bg-gradient-to-br from-blue-100 via-pink-50 to-purple-100 ">
      <div
  className="mx-auto bg-white p-8 rounded-lg shadow-2xl relative transition-transform transform hover:scale-105 duration-300"
  style={{ width: "50%", marginRight: "15%" }}>
          <h2 className="text-3xl text-pink-500 font-extrabold mb-6 text-center">Create Your Profile</h2>

          {/* <div className="flex flex-col items-center mb-4">
            <label className="block text-gray-600 font-semibold mb-2">Upload Photo:</label>
            <input type="file" name="photo" accept="image/*" onChange={handleFileChange} className="mb-2" />
            {formData.photo && (
              <div className="w-24 h-24 overflow-hidden rounded-full border-4 border-pink-300">
                <img src={URL.createObjectURL(formData.photo)} alt="Uploaded" className="w-full h-full object-cover" />
              </div>
            )}
          </div> */}

          <div className="flex flex-col items-center mb-4">
  <label className="block text-gray-700 font-semibold mb-3 text-lg">Upload Photo:</label>
  <input
    type="file"
    name="photo"
    accept="image/*"
    onChange={handleFileChange}
    className="mb-3 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
  />
  {formData.photo && (
    <div className="w-28 h-28 overflow-hidden rounded-full border-4 border-dotted border-purple-400 shadow-lg transition-transform duration-300 hover:scale-105">
      <img
        src={URL.createObjectURL(formData.photo)}
        alt="Uploaded"
        className="w-full h-full object-cover"
      />
    </div>
  )}
</div>


          <form onSubmit={handleSubmit} className="space-y-6 mb-10">
  {/* Name */}
  <div>
    <label className="block text-gray-600 font-semibold">Name:</label>
    <input
      type="text"
      name="name"
      placeholder="Enter Your Full Name"
      value={formData.name}
      onChange={handleChange}
      required
      className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
    />
  </div>

  {/* Main Fieldset */}
  <fieldset className="border border-gray-300 p-6 rounded-lg space-y-6">
    {/* Email & Password */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">Email:</label>
        <input
          type="email"
          name="email"
          placeholder="Enter Your Email Address"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
      <div className="relative">
      <label className="block text-gray-600 font-semibold">Password:</label>
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        value={formData.password}
        placeholder="Enter Your Password"
        onChange={handleChange}
        required
        className="w-full px-4 py-3 pr-12 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
      />
      <span
        className="absolute right-3 top-11 transform -translate-y-1/2 text-gray-500 cursor-pointer"
        onClick={togglePassword}
      >
        {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
      </span>
    </div>
    </div>

    {/* Mobile & Annual Income */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">Mobile:</label>
        <input
          type="text"
          name="mobile"
          value={formData.mobile}
          placeholder="Enter Your Mobile Number"
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Annual Income:</label>
        <select
          name="annual_income"
          value={formData.annual_income}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-lg shadow-sm"
        >
          <option value="" disabled>Select Your Income</option>
          <option value="1.5 Lakh to 4 Lakh">1.5 Lakh to 4 Lakh</option>
          <option value="4 Lakh to 8 Lakh">4 Lakh to 8 Lakh</option>
          <option value="8 Lakh to 10 Lakh">8 Lakh to 10 Lakh</option>
          <option value="above 10 Lakh">Above 10 Lakh</option>
        </select>
      </div>
    </div>

    {/* Marital Status & DOB */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">Marital Status:</label>
        <select
          name="marital_status"
          value={formData.marital_status}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-lg shadow-sm"
        >
          <option value="" disabled>Select Status</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
        </select>
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Date of Birth:</label>
        <input
          type="date"
          name="date_of_birth"
          value={formData.date_of_birth}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
    </div>

    {/* City & Gender */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">City:</label>
        <input
          type="text"
          name="city"
          placeholder="Enter Your City"
          value={formData.city}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Gender:</label>
        <select
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        >
          <option value="" disabled>Select Your Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>

    {/* Religion & Caste */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">Religion:</label>
        <select
          name="religion"
          value={formData.religion}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        >
          <option value="" disabled>Select Your Religion</option>
          <option value="Hindu">Hindu</option>
          <option value="Muslim">Muslim</option>
          <option value="Buddhism">Buddhism</option>
          <option value="Christian">Christian</option>
          <option value="Sikh">Sikh</option>
        </select>
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Caste:</label>
        <input
          type="text"
          name="caste"
          placeholder="Enter Your Caste"
          value={formData.caste}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
    </div>

    {/* Height & Education */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">Height (cm):</label>
        <input
          type="number"
          name="height"
          placeholder="Enter Your Height (in cm)"
          value={formData.height}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Education:</label>
        <input
          type="text"
          name="education"
          placeholder="Enter Your Education"
          value={formData.education}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
    </div>

    {/* Occupation */}
    <div>
      <label className="block text-gray-600 font-semibold">Occupation:</label>
      <input
        type="text"
        name="occupation"
        placeholder="Enter Your Occupation"
        value={formData.occupation}
        onChange={handleChange}
        className="w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
      />
    </div>

    {/* About & Looking For */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-gray-600 font-semibold">About Me:</label>
        <textarea
          name="about"
          value={formData.about}
          placeholder="Tell us something about yourself, your interests, or your background..."
          onChange={handleChange}
          className="w-full p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
          style={{ height: '150px' }}
        ></textarea>
      </div>
      <div>
        <label className="block text-gray-600 font-semibold">Looking for:</label>
        <textarea
          name="looking_for"
          value={formData.looking_for}
          placeholder="Looking for a caring and respectful partner from a good family background."
          onChange={handleChange}
          className="w-full p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
          style={{ height: '150px' }}
        ></textarea>
      </div>
    </div>
  </fieldset>

  {/* Submit Button */}
  <button
    type="submit"
    className="flex items-center justify-center mx-auto w-full max-w-xs py-3 bg-gradient-to-r from-green-400 to-blue-500 text-white font-bold rounded-lg shadow-lg hover:from-blue-500 hover:to-green-400 hover:shadow-xl transition duration-300"
  >
    <FiSend className="mr-2 text-lg" />
    Submit
  </button>
</form>

        </div>
      </div>
      {showPopup && (
  <div className="fixed">
    <div className="popup-container">
      <h3 className="popup-title">Success!</h3>
      <p className="popup-text">Profile created successfully.</p>
      <button
        onClick={() => setShowPopup(false)}
        className="popup-button"
      >
        OK
      </button>
    </div>
  </div>
)}

    </>
  );
};

export default AddProfileBtn;
